<template>
  <main class="content">
    <!-- content -->
    <section class="intro-next" v-if="group.name">
      <div class='container'>
        <div class="intro-next__wrapper">
          <div class="intro-next__col">
            <span class="intro__info">Российская общественная некоммерческая организация Экспертный центр ПАУ</span>
            <h1 class="intro-next__title">{{group.name}}</h1>
          </div>
          <div class="intro-next__img">
            <picture><source srcset="/static/assets/img/intro-next/bg.svg" type="image/webp"><img src="/static/assets/img/intro-next/bg.svg" alt="" /></picture>
          </div>
        </div>
      </div>
    </section>

    <section class="items" v-if="group.cf && group.cf[418] && group.cf[419] && group.cf[420] && group.cf[421]">
      <div class='container'>
        <div class="items__wrapper items-inner">
          <div class="items-inner__item">
            <div class="items-inner__title" v-if="group.cf[418]">{{group.cf[418]}}</div>
            <ul class="items-inner__list" v-if="group.cf[419]">
              <li class="items-inner__li" v-html="group.cf[419].replace(/\n/g, '<br>')"></li>
            </ul>
          </div>
          <div class="items-inner__item">
            <div class="items-inner__title" v-if="group.cf[420]">{{group.cf[420]}}</div>
            <ul class="items-inner__list" v-if="group.cf[421]">
              <li class="items-inner__li" v-html="group.cf[421].replace(/\n/g, '<br>')"></li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <Shedule v-if="timetable" :timetable.sync="timetable"/>

    <section class="return" v-if="group.cf && group.cf[422] && group.cf[423]">
      <div class='container'>
        <div class="return__inner">
          <div class="return__item">
            <h2 class="return__title" v-if="group.cf[422]">{{group.cf[422]}}</h2>
            <ul class="return__list" v-if="group.cf[423]">
              <li v-html="(group.cf[423]).replace(/\n/g, '<br>')"></li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <section class="category">
      <div class="swiper-sl" v-for="program in programs" :key="program.id" v-if="parseInt(program.cf[435]) === parseInt(group.id)">
        <div class="category-slider__item-wrapper">
          <div class="category-slider__item item-slider">
            <div class="item-slider__picture">
              <picture><img v-if="program.cf[448]" :src="program.cf[448]" alt="" /></picture>
            </div>
            <div class="item-slider__text">
              {{program.name}}
            </div>
            <div class="item-slider__btn-wrapper">
              <button class="item-slider__btn" :data-program="program.id">Записаться</button>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="check">
      <div class='container'>
        <div class="check__wrapper">
          <div class="check__item item-check">
            <h2 class="item-check__title" v-if="group.cf[426]">{{group.cf[426]}}</h2>
            <h2 class="item-check__title" v-else>Этого нет на YouTube</h2>
            <div class="item-check__text" v-if="group.cf[427]" v-html="group.cf[427].replace(/\n/g, '<br>')"></div>
            <div class="item-check__text" v-else>
              <p>Мы поможем быстро разобраться в решении Вашего вопроса, подготовить правильную линию защиты и все это стоит всего 350 рублей.</p>
            </div>
          </div>
          <div class="check__item item-check">
            <h2 class="item-check__title" v-if="group.cf[428]">{{group.cf[428]}}</h2>
            <h2 class="item-check__title" v-else>Уже были у юристов? Проверьте их работу!</h2>
            <div class="item-check__text" v-if="group.cf[429]" v-html="(group.cf[429]).replace(/\n/g, '<br>')"></div>
            <div class="item-check__text" v-else>
              <p>Сколько Вы заплатили или собираетесь заплатить юристу?</p>
              <p>Вы не специалист и вряд ли разбираетесь в вопросе, но…Вам ведь важно решить проблему, а не просто заплатить деньги адвокату или юристу, да еще и не малые!</p><br/>
              <p>Потратьте 350 рублей и 2 часа времени и Вы поймете насколько компетентны юристы к которым вы обратились. Вам будет с чем сравнить.</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="get">
      <div class='container'>
        <div class="get__inner">
          <h2 class="get__title" v-if="group.cf[430]">{{group.cf[430]}}</h2>
          <h2 class="get__title" v-else>Вы получаете</h2>
          <p class="get__subtitle" v-if="group.cf[431]">{{group.cf[431]}}</p>
          <p class="get__subtitle" v-else>Пошаговое руководство “Как вернуть права”.
            Что вам делать? Как делать? Когда?</p>
          <div class="get__wrapper">
            <div class="get__item" v-if="group.cf[432]">
              <div class="get__picture">
                <picture><source srcset="/static/assets/img/get/1.svg" type="image/webp"><img src="/static/assets/img/get/1.svg" alt="" /></picture>
              </div>
              <h3 class="get__text">{{group.cf[432]}}</h3>
            </div>
            <div class="get__item" v-else>
              <div class="get__picture">
                <picture><source srcset="/static/assets/img/get/1.svg" type="image/webp"><img src="/static/assets/img/get/1.svg" alt="" /></picture>
              </div>
              <h3 class="get__text">Понятно и доступно для всех</h3>
            </div>

            <div class="get__item" v-if="group.cf[433]">
              <div class="get__picture">
                <picture><source srcset="/static/assets/img/get/2.svg" type="image/webp"><img src="/static/assets/img/get/2.svg" alt="" /></picture>
              </div>
              <h3 class="get__text">{{group.cf[433]}}</h3>
            </div>
            <div class="get__item" v-else>
              <div class="get__picture">
                <picture><source srcset="/static/assets/img/get/2.svg" type="image/webp"><img src="/static/assets/img/get/2.svg" alt="" /></picture>
              </div>
              <h3 class="get__text">Без нравоучений и наставлений</h3>
            </div>

            <div class="get__item" v-if="group.cf[434]">
              <div class="get__picture">
                <picture><source srcset="/static/assets/img/get/3.svg" type="image/webp"><img src="/static/assets/img/get/3.svg" alt="" /></picture>
              </div>
              <h3 class="get__text">{{group.cf[434]}}</h3>
            </div>
            <div class="get__item" v-else>
              <div class="get__picture">
                <picture><source srcset="/static/assets/img/get/3.svg" type="image/webp"><img src="/static/assets/img/get/3.svg" alt="" /></picture>
              </div>
              <h3 class="get__text">Без «воды» - все конкретно по Вашему делу</h3>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="video-wr">
      <div class='container'>
        <div class="video__wrapper">
          <h2 class="video__title">Посмотрите как это работает</h2>
          <div class="video__inner">
            <div class="sw-container" data-mobile="false">
              <div class="sw-wrapper">
                <!-- <div class="sw-slider">
                  <div class="video__item">
                    <div class="video-link">
                      <iframe src="https://www.youtube.com/embed/cLPx7HrVta4"></iframe>
                    </div>
                    <div class="vide-text">
                      Сайт рыбатекст поможет дизайнеру, верстальщику, вебмастеру сгенерировать несколько абзацев более менее осмысленного текста рыбы на русском языке.
                    </div>
                  </div>
                </div> -->
                <div class="sw-slider">
                  <div class="video__item">
                    <div class="video-link">
                      <iframe src="https://www.youtube.com/embed/cLPx7HrVta4"></iframe>
                    </div>
                    <div class="vide-text">
                      СМАРТ.юрист - проверенный способ решения любой проблемы. Вы всего через 1 час сможете решить юридический вопрос без обращения к юристам и адвокатам.
                    </div>
                  </div>
                  <div class="video__item">
                    <div class="video-link">
                      <iframe src="https://www.youtube.com/embed/DxGUT_b6l-M"></iframe>
                    </div>
                    <div class="vide-text">
                      Решите любой юридический вопрос проверенным эффективным способом! Сам себе юрист? Это реально и не требует никаких дополнительных расходов.
                    </div>
                  </div>
                </div>
                <!-- <div class="sw-slider">
                  <div class="video__item">
                    <div class="video-link">
                      <iframe src="https://www.youtube.com/embed/cLPx7HrVta4"></iframe>
                    </div>
                    <div class="vide-text">
                      Сайт рыбатекст поможет дизайнеру, верстальщику, вебмастеру сгенерировать несколько абзацев более менее осмысленного текста рыбы на русском языке.
                    </div>
                  </div>
                </div> -->
              </div>
            </div>
            <div class="swiper__pagination"></div>
          </div>
        </div>
      </div>
    </section>

    <section class="work">
      <div class='container'>
        <div class="work__wrapper">
          <div class="work__inner inner-work">
            <div class="inner-work__col">
              <span class="inner-work__pictures"> <picture><source srcset="/static/assets/img/work/1.svg" type="image/webp"><img src="/static/assets/img/work/1.svg" width="36" height="36" alt="" /></picture> </span>
              <div class="inner-work__text">
                <h3 class="inner-work__title">Экономия до 99%</h3>
                <p class="inner-work__subtitle">от стоимости юридических услуг</p>
              </div>
            </div>
            <div class="inner-work__col">
              <span class="inner-work__pictures"> <picture><source srcset="/static/assets/img/work/2.svg" type="image/webp"><img src="/static/assets/img/work/2.svg" width="36" height="36" alt="" /></picture> </span>
              <div class="inner-work__text">
                <h3 class="inner-work__title">5 минут или 24 часа</h3>
                <p class="inner-work__subtitle">предоставим аналогичные документы по выигранным делам за 5 минут или подготовим индивидуально за 24 часа</p>
              </div>
            </div>
            <div class="inner-work__col">
              <span class="inner-work__pictures"> <picture><source srcset="/static/assets/img/work/3.svg" type="image/webp"><img src="/static/assets/img/work/3.svg" width="36" height="36" alt="" /></picture> </span>
              <div class="inner-work__text">
                <h3 class="inner-work__title">10 лет</h3>
                <p class="inner-work__subtitle">Минимальный опыт работы <br> юриста</p>
              </div>
            </div>
          </div>
          <div class="intro__video work-video">
            <a class="intro__btn"  @click="showModal(5,'<iframe src=\'https://www.youtube.com/embed/cLPx7HrVta4\'></iframe>')">
              <picture><source srcset="/static/assets/img/intro/play.svg" type="image/webp"><img src="/static/assets/img/intro/play.svg" alt="" /></picture>
              <span>Смотреть видео</span>
            </a>
          </div>
        </div>
      </div>
    </section>
    <!--section class="news">
      <div class='container'>
        <div class="news__wrapper">
          <div class="news__title">Новости</div>
          <div class="news__inner">
            <div class="news-swiper-container">
              <div class="news-swiper-wrapper">
                <router-link tag="div" :to="'/news/' + sNews.id" class="news-swiper-slide" v-for="sNews in news" :key="sNews.id" v-if="sNews.cf[417]">
                  <div class="news__item item-news">
                    <div class="item-news__picture">
                      <picture><img :src="sNews.cf[417]" alt="" /></picture>
                    </div>
                    <div class="item-news__text">
                      <h1 class="item-news__title">{{sNews.name}}</h1>
                    </div>
                  </div>
                </router-link>
              </div>
            </div>
            <div class="news-swiper-pagination"></div>
            <div class="news-swiper-button-prev"></div>
            <div class="news-swiper-button-next"></div>
          </div>
        </div>
      </div>
    </section-->
  </main>
</template>

<script>
import axios from '@/router/http'
import Shedule from '@/components/include/shedule'
import $ from 'jquery'
export default {
  name: 'groups',
  components: {Shedule},
  data () {
    return {
      group: {},
      programs: [],
      timetable: [],
      news: []
    }
  },
  mounted () {
    let self = this
    $(document).on('click', '[data-program]', function () {
      self.$router.push({path: '/smart/program/' + $(this).data('program')})
    })
    axios.get('https://smart.v-avtoservice.com/list/get-lists?id=35').then(response => {
      this.news = response.data
      setTimeout(() => {
        this.initSlider()
      }, 1000)
    })
    axios.get('https://smart.v-avtoservice.com/list/get-listc?id=' + this.$route.params.id).then(response => {
      this.group = response.data
      axios.get('https://smart.v-avtoservice.com/list/get-lists?id=37').then(response => {
        this.programs = response.data
        let ids = []
        this.programs.forEach(val => parseInt(val.cf[435]) === parseInt(this.group.id) ? ids.push(val.id) : '')
        if (ids.length) {
          axios.get('https://smart.v-avtoservice.com/list/get-time-table?wheres=' + ids).then(response => {
            this.timetable = response.data
          })
        }

        setTimeout(() => {
          this.initSlider2()
        }, 1000)
      })
    })
  },
  methods: {
    initSlider () {
      // eslint-disable-next-line
      new Swiper('.news-swiper-container', {
        pagination: {
          el: '.news-swiper-pagination',
          type: 'bullets',
          clickable: true,
          renderBullet: function (index, className) {
            return '<span class="' + className + '">' + (index + 1) + '</span>'
          }
        },
        observer: true,
        wrapperClass: 'news-swiper-wrapper',
        slideClass: 'news-swiper-slide',
        observeParents: true,
        slidesPerView: 3,
        spaceBetween: 0,

        speed: 800,
        loop: true,
        navigation: {
          nextEl: '.news-swiper-button-next',
          prevEl: '.news-swiper-button-prev'
        },
        breakpoints: {
          320: {
            slidesPerView: 1
          },
          533: {
            slidesPerView: 1
          },
          560: {
            slidesPerView: 2
          },
          728: {
            slidesPerView: 2
          },
          767: {
            slidesPerView: 2
          },
          992: {
            slidesPerView: 3
          },
          1292: {
            slidesPerView: 3
          }
        }
      })
    },
    showModal (id, text) {
      this.$root.requestModal = id
      this.$root.requestModalText = text
    },
    initSlider2 () {
      // eslint-disable-next-line
      new Swiper('.swiper-cnt', {
        pagination: {
          el: '.swiper-pag',
          type: 'bullets',
          clickable: true,
          renderBullet: function (index, className) {
            return '<span class="' + className + '">' + (index + 1) + '</span>'
          }
        },
        observer: true,
        wrapperClass: 'swiper-wr',
        slideClass: 'swiper-sl',
        observeParents: true,
        slidesPerView: 5,
        spaceBetween: 0,

        speed: 800,
        loop: false,
        navigation: {
          nextEl: '.swiper-next',
          prevEl: '.swiper-prev'
        },
        breakpoints: {
          320: {
            slidesPerView: 1
          },
          533: {
            slidesPerView: 1
          },
          560: {
            slidesPerView: 2
          },
          728: {
            slidesPerView: 3
          },
          767: {
            slidesPerView: 3
          },
          992: {
            slidesPerView: 4
          },
          1292: {
            slidesPerView: 5
          }
        }
      })
    }
  }
}
</script>

<style scoped>
  .block-slider__img img {
    max-width: 340px;
    max-height: 200px;
  }
  .block-slider__img {
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/smartGroup.vue